import React, { useMemo, useCallback } from 'react';
import {
  usePageFilterSortReducer,
  initialStateDefault,
  DEFAULT_PAGE_SIZE,
} from 'hooks/usePageFilterSortReducer';
import { useInvestAccounts } from './apiHooks/useInvestAccounts';
import Loading from 'components/Loading';
import PaginationNew from 'components/Pagination/PaginationNew';
import InfoMessage from 'components/InfoMessage';
import { FilterFields } from './components/FilterFields';
import { AccountsTable } from './components/AccountsTable';

export function InvestAccounts() {
  const [state, dispatch] = usePageFilterSortReducer({
    ...initialStateDefault,
    filter: {
      brokerNameOrContractNumber: '',
      iisOpenDateFrom: null,
      iisOpenDateTo: null,
      isShowOnlyOpenedIis: false,
    },
  });

  const { data: accountsResp, isLoading, isFetching } = useInvestAccounts(state);

  const hasFilter = useMemo(() => {
    const { brokerNameOrContractNumber, iisOpenDateFrom, iisOpenDateTo, isShowOnlyOpenedIis } =
      state.filter;
    return Boolean(
      brokerNameOrContractNumber || iisOpenDateFrom || iisOpenDateTo || isShowOnlyOpenedIis,
    );
  }, [state.filter]);

  const hasContent = (accountsResp?.content ?? []).length > 0;

  const totalPages = accountsResp?.totalPages ?? 1;

  const handlePaginationChange = useCallback((page) => {
    dispatch({ type: 'setPagination', payload: page });
  }, []);

  const handleSortedChange = useCallback((sortBy) => {
    const sortParams = sortBy.map((param) => {
      return {
        name: param.id,
        order: param.desc ? 'desc' : 'asc',
      };
    });
    dispatch({ type: 'setSort', payload: sortParams });
  }, []);

  const handleFilterChange = useCallback((filter) => {
    dispatch({ type: 'setFilter', payload: filter });
  }, []);

  return (
    <div className={`white-block__pad40 pt-0 boo`}>
      {isLoading && (
        <div className={'position-relative'}>
          <Loading />
        </div>
      )}

      {!isLoading && (
        <>
          <FilterFields filterParams={state.filter} onChange={handleFilterChange} />

          {hasFilter && !hasContent && (
            <InfoMessage>Данных не найдено. Попробуйте уточнить запрос.</InfoMessage>
          )}

          {(!hasFilter || hasContent) && (
            <AccountsTable
              accountsContent={accountsResp?.content ?? []}
              isLoading={isFetching}
              onSortedChange={handleSortedChange}
            />
          )}

          {totalPages > 1 && (
            <div className={'m-4 d-flex justify-content-end'}>
              <PaginationNew
                hidePerPage
                size={DEFAULT_PAGE_SIZE}
                number={state.pagination.page}
                totalElements={accountsResp?.totalElements}
                totalPages={totalPages}
                onChange={handlePaginationChange}
              />
            </div>
          )}
        </>
      )}
    </div>
  );
}
